import React from 'react';
import { Loader, Download } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

/**
 * A reusable Excel Export Button component with a premium pill-shaped design.
 * Now dynamically follows the application theme.
 */
const ExcelExportButton = ({ onClick, isDownloading, label = 'DOWNLOAD', className = '' }) => {
  const { currentTheme } = useTheme();
  
  return (
    <button
      onClick={onClick}
      disabled={isDownloading}
      className={`
        relative overflow-hidden group
        px-6 py-2.5 desktop:px-8 desktop:py-3 
        text-white rounded-full transition-all duration-300
        flex items-center gap-3 shadow-lg
        hover:scale-[1.02] active:scale-[0.98]
        disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100
        ${className}
      `}
      style={{ 
        backgroundColor: currentTheme?.color || '#2196f3',
        boxShadow: `0 4px 14px 0 ${currentTheme?.color || '#2196f3'}66`
      }}
      title={label}
    >
      {/* Glossy overlay effect for premium look */}
      <div className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/20 to-transparent pointer-events-none" />
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" />
      
      {isDownloading ? (
        <Loader className="w-5 h-5 desktop:w-6 desktop:h-6 animate-spin" />
      ) : (
        <>
          <span className="font-black text-sm desktop:text-base tracking-wider uppercase drop-shadow-sm relative z-10">
            {label}
          </span>
          <Download className="w-5 h-5 desktop:w-6 desktop:h-6 drop-shadow-sm relative z-10" />
        </>
      )}
      
      {isDownloading && (
        <span className="font-black text-sm desktop:text-base tracking-wider uppercase drop-shadow-sm relative z-10">
          DOWNLOADING...
        </span>
      )}
    </button>
  );
};

export default ExcelExportButton;
